<template>

    <v-dialog
            v-model="dialogModel"
            max-width="550px"
            persistent
            eager
    >

        <toolbar-page title="Edit user" icon="mdi-shield-account">
            <template slot="buttons">
                <v-btn @click="closeDialog" icon>
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </template>
        </toolbar-page>

        <validation-observer ref="validationObserver" v-slot="{ invalid }">

            <v-form v-model="valid" ref="form" id="form">
                <v-card width="100%">
                    <v-card-text>

                        <v-container fluid class="pa-0">
                            <v-row no-gutters>
                                <v-col cols="12">
                                    <validation-provider name="User name"
                                                         rules="required|alpha_spaces|min:3|max:60"
                                                         v-slot="{errors}"
                                                         mode="lazy">
                                        <v-text-field
                                                class="align-self-center"
                                                label="User name"
                                                v-model="form.data.name"
                                                :counter="60"
                                                required
                                                prepend-icon="mdi-shield-account"
                                                :error-messages="errors"
                                        ></v-text-field>
                                    </validation-provider>
                                </v-col>
                            </v-row>

                            <v-row no-gutters>
                                <v-col cols="12">
                                    <validation-provider name="Email address"
                                                         rules="min:3|max:50|email"
                                                         mode="lazy"
                                                         v-slot="{ errors }">
                                        <v-text-field
                                                name="email"
                                                label="Email"
                                                v-model="form.data.email"
                                                prepend-icon="mdi-email"
                                                :error-messages="errors"
                                        ></v-text-field>
                                    </validation-provider>
                                </v-col>
                            </v-row>

                            <v-row no-gutters>
                                <v-col cols="12">
                                    <cell-phone-field
                                            :country-code="form.data.country_code"
                                            :phone-number="form.data.phone"
                                            :error-messages="form.getError('phone')"
                                            @country-code-selected="countryCodeSelected"
                                            @phone-number-input="phoneNumberInput"
                                            :error-messages-country-code="form.getError('country_code')"
                                            :error-messages-phone-number="form.getError('phone')"
                                    />

                                </v-col>

                            </v-row>

                            <v-row no-gutters>
                                <v-col cols="12">

                                    <v-select
                                            v-if="timezones"
                                            label="Timezone"
                                            :items="timezones"
                                            v-model="form.data.timezone"
                                            required
                                            prepend-icon="mdi-earth"
                                            :error-messages="form.getError('timezone')"
                                    ></v-select>

                                    <v-btn class="ml-6 mt-2 mb-2 align-self-center"
                                           color="primary"
                                           @click="saveUser"
                                           :loading="saving"
                                           :disabled="submitButtonDisabled">
                                        Update User
                                    </v-btn>

                                </v-col>

                            </v-row>

                        </v-container>

                    </v-card-text>

                </v-card>
            </v-form>

        </validation-observer>

    </v-dialog>

</template>

<script>

import {mapActions,mapState} from 'vuex';
import Form from '../../../../components/forms/Form';
import ToolbarPage from '../../../../components/UI/ToolbarPage';
import Json from 'vue-json-pretty';
import CellPhoneField from "../../../../components/UI/CellPhoneField";
import {timeDisplay} from "../../../../components/mixins/timeDisplayMixin";

const vuexStore = 'UserManager';

export default {

    components: {
        ToolbarPage,
        CellPhoneField,
        Json
    },

    mixins: [timeDisplay],

    props: {
        value: {
            type: Boolean,
            required: true
        },
        user: {
            type: Object,
            required: false,
        },
        errorMessages: {
            type: Object,
            required: false,
        },
        loading: {
            type: Boolean,
            required: false,
            default: false,
        }
    },

    data() {
        return {
            form: new Form({
                name: '',
                email: '',
                country_code: '',
                phone: '',
                timezone: '',
            }),
            valid: false,
            saving: false,
            window: {
                width: null,
                height: null,
            }
        }
    },

    computed: {

        ...mapState([
            'timezones'
        ]),

        dialogModel: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit('input', value);
            }
        },

        submitButtonDisabled() {
            if (!this.hasPermission('create roles')) return true;
            if (this.form.busy) return true;
        }
    },

    watch: {
        user(user) {
            if (user) {
                this.prepareSelected();
            }
        }
    },

    methods: {

        // Root store
        ...mapActions([
            'loadTimezones'
        ]),

        ...mapActions(vuexStore, [
            'updateUser'
        ]),

        prepareSelected() {
            this.form.data.name = this.user.name;
            this.form.data.email = this.user.email;
            this.form.data.country_code = '+' + this.user.country_code;
            this.form.data.phone = this.user.phone;
            this.form.data.timezone = this.user.timezone;
        },

        saveUser() {

            this.saving = true;

                let data = {
                    id: this.user.id,
                    name: this.form.data.name,
                    email: this.form.data.email,
                    country_code: this.form.data.country_code.replace(/\+/g, ''),
                    phone: this.form.data.phone,
                    timezone: this.form.data.timezone
                };

                this.valuesChanged();

                this.updateUser(data)
                    .then(() => {
                        Bus.$emit('flash-message', {
                            message: data.name + ' user successfully updated!'
                        })
                        this.closeDialog();
                    })
                    .catch((error) => {
                        if (error.status === 422) {
                            Bus.$emit('flash-message', {type: 'error', message: error.data.message});
                            return;
                        }

                        Bus.$emit('server-error', {type: 'error', message: error.data.message});
                    })
                    .finally(() => {
                        this.saving = false;
                    });

        },

        countryCodeSelected(value) {
            this.form.data.country_code = value;
        },

        phoneNumberInput(value) {
            this.form.data.phone = value;
        },

        closeDialog() {
            this.$emit('input', false);
        },

        valuesChanged() {
            if (this.$refs.compensationObserver) {
                this.$refs.compensationObserver.validate()
                    .then(isValid => {
                        if (isValid) {
                            this.$emit('change', this.data);
                            this.$emit('error', {name: 'tab7', error: false});
                        } else {
                            this.$emit('error', {name: 'tab7', error: true});
                        }
                    });
            }
        }
    },

    mounted() {
        this.loadTimezones();
    }
}
</script>